<template>
    <div class="folder-tree">
        <div v-for="(folder,index) in local_folders" :key="index">
            <div class="parent-item">
                <Icon @click.stop="toggleFolder(folder,index)" :type="folder.expanded?'ios-arrow-down':'ios-arrow-forward'" size="22" />
                <div class="folder-name" @click.stop="onFolderSelect(folder)">
                    <img src="@/assets/images/team/icon-team-file.png" alt="" class="folder-icon">
                    <div class="name">{{ folder.name }}</div>
                </div>
                <Icon v-if="selectedFolder.uuid === folder.uuid" type="md-checkmark" class="selected-icon" />
            </div>
            <!-- {{ child_folders.length }} {{ folder.expanded }} -->
            <div v-if="folder.expanded && folder.children && folder.children.length > 0" class="children">
                <!-- 123 -->
                <folder-tree 
                    :folders="folder.children" 
                    :level="level + 1"
                    :selectedFolder="selectedFolder"
                    :parentFolder="folder.uuid"
                    @select-folder="onFolderSelect($event)"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { teamFolderFileList } from '@/api/index';
export default{
    name:"FolderTree",
    components: {
        FolderTree: () => import('./FolderTree.vue')
    },
    props:{
        folders:{
            type:Array,
            default:()=>[]
        },
        level:{
            type:Number,
            default:0
        },
        selectedFolder:{
            type:Object,
            default:()=>({})
        },
        parentFolder:{
            type:String,
            default:''
        },
    },
    data(){
        return {
            child_folders:[],
            team_uuid:'',
            parent_uuid:'',
            local_folders:[]
        }
    },
    watch: {
        folders: {
            handler(newFolders) {
                // 创建响应式本地副本
                this.local_folders = JSON.parse(JSON.stringify(newFolders));
                this.initFolders(this.local_folders);
            },
            immediate: true
        },
        selectedFolder:{
            handler(newVal){
                console.log('selectedFolder',newVal);
            },
            deep:true
        }
    },
    
    methods:{
        initFolders(folders) {
            if (!folders || !Array.isArray(folders)) return;
            
            folders.forEach(folder => {
                // 确保每个文件夹都有响应式的 expanded 属性
                if (folder.expanded === undefined) {
                    this.$set(folder, 'expanded', false);
                }
            });
        },
        async onGetChildFolderList(index){
            try{
                const param = {};
                param.team_uuid = this.team_uuid;
                param.parent_directory_uuid = this.parent_uuid || this.parentFolder;
                console.log('param===>get-child',param);
                const {code,msg,data} = await teamFolderFileList(param)
                console.log('data===>get-child',data);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$set(this.local_folders[index],'children',[]);
                if(!data.length){
                    this.$layer.msg('没有更多了~');
                    return;
                }
                const res = data.map(item=>{return {...item,expanded:false}}).filter(item=>item.is_dir);
                this.$set(this.local_folders[index],'children',res);
                // this.child_folders = res;
                console.log('this.child_folders',this.child_folders);
            }catch(e){
                console.log('err-get-child-folder-list',e);
                this.$layer.msg(e.msg);
            }
        },
        onFolderSelect(folder){
            this.$emit('select-folder',folder)
        },
        async toggleFolder(folder,index){
            console.log('aaa',folder);
            console.log('folder-name',folder.name);
            this.team_uuid = folder.team_uuid;
            this.parent_uuid = folder.uuid;
            await this.onGetChildFolderList(index);
            // if(this.child_folders && this.child_folders.length > 0){
                this.$set(folder,'expanded',true);
                // console.log('child--->',folder)
            // }
        }
    }
}
</script>
<style lang="scss" scoped>
    .folder-tree{
        width:100%;
        padding-left:17px;
        .parent-item{
            width:100%;
            height:35px;
            display:flex;
            align-items:center;
            column-gap:10px;
            cursor:pointer;
            // padding-left:17px;
            &:hover{
                background:#f5f5f5;
            }
            .folder-name{
                display:flex;
                align-items:center;
                flex:1;
                column-gap:7px;
                .folder-icon{
                    width:24px;
                    height:24px;
                }
                .name{
                    flex:1;
                    color:#333333;
                    font-size:14px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
            }
            .selected-icon{
                color:#ff5967;
                margin-right:10px;
            }
        }
    }
</style>